import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaMobileAlt,
  FaDatabase,
  FaCloud,
  FaFigma,
} from "react-icons/fa";
import {
  SiNextdotjs,
  SiJavascript,
  SiLaravel,
  SiFirebase,
  SiAmazonaws,
} from "react-icons/si";

import "./TechStack.css";

const TechStack = () => {
  return (
    <section className="oglitz-techstack" aria-labelledby="techstack-title">
      <div className="oglitz-techstack__inner">
        <span className="oglitz-techstack__badge">Technology Stack</span>

        <h2 id="techstack-title" className="oglitz-techstack__title">
          <span className="line-1">Technologies We Use to Build</span>
          <span className="line-2">Scalable Digital Products</span>
        </h2>

        <p className="oglitz-techstack__desc">
          Modern, proven technologies powering secure, high-performance web,
          mobile, and enterprise software solutions.
        </p>

        <div className="oglitz-techstack__grid">
          {/* Frontend */}
          <article className="oglitz-techstack__card">
            <h3>Frontend</h3>
            <ul>
              <li>
                <FaReact /> React
              </li>
              <li>
                <SiNextdotjs /> Next.js
              </li>
              <li>
                <FaHtml5 /> HTML5
              </li>
              <li>
                <FaCss3Alt /> CSS3
              </li>
              <li>
                <SiJavascript /> JavaScript
              </li>
            </ul>
          </article>

          {/* Backend */}
          <article className="oglitz-techstack__card">
            <h3>Backend</h3>
            <ul>
              <li>
                <FaNodeJs /> Node.js
              </li>
              <li>
                <SiLaravel /> Laravel
              </li>
              <li>
                <SiFirebase /> Firebase
              </li>
              <li>
                <FaDatabase /> Databases
              </li>
            </ul>
          </article>

          {/* Mobile */}
          <article className="oglitz-techstack__card">
            <h3>Mobile</h3>
            <ul>
              <li>
                <FaMobileAlt /> React Native
              </li>
              <li>
                <FaMobileAlt /> Android & iOS
              </li>
            </ul>
          </article>

          {/* Cloud & DevOps */}
          <article className="oglitz-techstack__card">
            <h3>Cloud & DevOps</h3>
            <ul>
              <li>
                <SiAmazonaws /> AWS
              </li>
              <li>
                <FaCloud /> CI / CD
              </li>
              <li>
                <FaCloud /> Cloud Hosting
              </li>
            </ul>
          </article>

          {/* Design */}
          <article className="oglitz-techstack__card">
            <h3>Design</h3>
            <ul>
              <li>
                <FaFigma /> Figma
              </li>
              <li>
                <FaFigma /> UI Systems
              </li>
              <li>
                <FaFigma /> Prototyping
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
